const Config = {
    API_ROOT: process.env.REACT_APP_API_ROOT ? process.env.REACT_APP_API_ROOT : 'https://api.sfintra.net',
    LOCAL_STORAGE_KEY: 'sf-review-token',
}

export default Config;
